import React, { useState } from 'react';
import { Container, Card, Button, Table, Row, Col, Form, InputGroup, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faDownload, faFileAlt, faFilePdf, faEye } from '@fortawesome/free-solid-svg-icons';

const Documents = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  
  // Updated documents data with external URLs
  const documents = [
    { 
      id: 1, 
      name: 'Mobilitätsgarantie_Martens_Prahl_Mobilitätsgarantiebedingungen.pdf', 
      displayName: 'Mobilitätsgarantie Bedingungen',
      type: 'pdf', 
      size: '0.9 MB', 
      date: '01/01/2026',
      url: 'https://select-gruppe.de/fileadmin/Downloads/Mobi/Mobilitätsgarantie_Martens_Prahl_Mobilitätsgarantiebedingungen.pdf'
    },
    { 
      id: 2, 
      name: '20260101_Übersicht_Mobilitätsgarantie_REKOGA_2026.pdf', 
      displayName: 'Übersicht Mobilitätsgarantie REKOGA',
      type: 'pdf', 
      size: '1.2 MB', 
      date: '01/01/2026',
      url: 'https://select-gruppe.de/fileadmin/Downloads/Mobi/20260101_Übersicht_Mobilitätsgarantie_REKOGA_2026.pdf'
    },
  ];
  
  // Filter documents based on search term
  const filteredDocuments = documents.filter(doc => 
    doc.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    doc.displayName.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  // Get icon based on document type
  const getDocumentIcon = (type) => {
    switch(type) {
      case 'pdf':
        return faFilePdf;
      default:
        return faFileAlt;
    }
  };
  
const handleDownload = (doc) => {
  console.log(`Initiating download for: ${doc.name} from ${doc.url}`);
  
  // Create a link to the external URL
  const link = document.createElement('a');
  link.href = doc.url;
  link.setAttribute('download', doc.name);
  link.setAttribute('target', '_blank');
  document.body.appendChild(link);
  
  // Trigger download
  link.click();
  link.remove();
};
  
  // Preview document
  const handlePreview = (document) => {
    setSelectedDocument(document);
    setShowPreviewModal(true);
  };
  
  return (
    <Container>
      <h2 className="mb-4">Documents</h2>
      
      <Card className="mb-4">
        <Card.Body>
          <Row className="mb-3 align-items-center">
            <Col md={6} className="mb-2 mb-md-0">
              <InputGroup>
                <InputGroup.Text>
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Dokumente durchsuchen..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </InputGroup>
            </Col>
          </Row>
          
          <div className="table-responsive">
            <Table hover className="mb-0">
              <thead className="bg-light">
                <tr>
                  <th>Dokumentname</th>
                  <th>Typ</th>
                  <th>Größe</th>
                  <th>Datum</th>
                  <th className="text-center">Aktionen</th>
                </tr>
              </thead>
              <tbody>
                {filteredDocuments.map(doc => (
                  <tr key={doc.id}>
                    <td>
                      <FontAwesomeIcon 
                        icon={getDocumentIcon(doc.type)} 
                        className="me-2" 
                        color={doc.type === 'pdf' ? '#dc3545' : '#0d6efd'} 
                      />
                      {doc.displayName}
                      <div className="small text-muted">{doc.name}</div>
                    </td>
                    <td className="text-uppercase">{doc.type}</td>
                    <td>{doc.size}</td>
                    <td>{doc.date}</td>
                    <td className="text-center">
                      <Button 
                        variant="outline-secondary" 
                        size="sm" 
                        className="me-2"
                        onClick={() => handlePreview(doc)}
                      >
                        <FontAwesomeIcon icon={faEye} className="me-1" />
                        Vorschau
                      </Button>
                      <Button 
                        variant="outline-primary" 
                        size="sm" 
                        onClick={() => handleDownload(doc)}
                      >
                        <FontAwesomeIcon icon={faDownload} className="me-1" />
                        Download
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          
          {filteredDocuments.length === 0 && (
            <div className="text-center p-3">
              <p className="text-muted">Keine Dokumente gefunden, die Ihrer Suche entsprechen.</p>
            </div>
          )}
        </Card.Body>
      </Card>
      
      {/* Document Preview Modal */}
      <Modal 
        show={showPreviewModal} 
        onHide={() => setShowPreviewModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon 
              icon={getDocumentIcon(selectedDocument?.type)} 
              className="me-2" 
              color={selectedDocument?.type === 'pdf' ? '#dc3545' : '#0d6efd'} 
            />
            {selectedDocument?.displayName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <div className="mb-3 small text-muted">
              {selectedDocument?.name}
            </div>
            <iframe 
              src={selectedDocument ? selectedDocument.url : ''}
              width="100%" 
              height="500px" 
              title={selectedDocument?.displayName}
              className="border-0"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowPreviewModal(false)}>
            Schließen
          </Button>
          <Button 
            variant="primary" 
            onClick={() => selectedDocument && handleDownload(selectedDocument)}
          >
            <FontAwesomeIcon icon={faDownload} className="me-1" />
            Herunterladen
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Documents;